import cx from 'classnames';

import { BackgroundLayout } from 'Components/BackgroundLayout/BackgroundLayout';
import cypressIds from 'Components/cypress_ids.json';
import { SectionLoader } from 'Components/SectionLoader/SectionLoader';
import { applyTestIdData } from 'Utilities/helpers';

import type { PageSectionLayoutProps } from './PageSectionLayout.types';
import { SectionError } from './SectionError';

import styles from './PageSectionLayout.module.scss';

export const PageSectionLayout: React.FC<PageSectionLayoutProps> = ({
	action,
	backgroundLayout,
	children,
	error,
	icon,
	isPrint,
	loading,
	title,
}) => {
	return (
		<BackgroundLayout className={cx({ [styles.print]: isPrint })} {...backgroundLayout}>
			<div className={styles.header}>
				<h2 className={styles.title} {...applyTestIdData(cypressIds.containers.pageSectionLayoutTitle)}>
					{title}
				</h2>
				<div {...applyTestIdData(cypressIds.containers.pageSectionLayoutAction)}>{action}</div>
			</div>
			{loading && (
				<div className={styles.loader} {...applyTestIdData(cypressIds.containers.pageSectionLayoutLoader)}>
					<SectionLoader />
				</div>
			)}
			{error && <SectionError icon={icon} />}
			{!loading && !error && <div {...applyTestIdData(cypressIds.containers.pageSectionLayoutContent)}>{children}</div>}
		</BackgroundLayout>
	);
};
